import { isNavItemActive } from "@/features/navigation"

export function resolveActiveSidebarHref(
  pathname: string,
  hrefs: readonly (string | null)[]
) {
  const matches = hrefs.filter(
    (href): href is string => href !== null && isNavItemActive(pathname, href)
  )

  if (matches.length === 0) return null

  return matches.reduce((longest, href) =>
    href.length > longest.length ? href : longest
  )
}
